<template>
    <el-card shadow="hover" :body-style="{
        padding:'5px',
        height: '100%',
        backgroundColor:data.required == 1 ? 'rgba(77,142,246,0.2)' : 'rgba(105,187,64,0.2)'}" class="lesson"
        >
        <div class="required" :style="data.required == 1 ? {backgroundColor:'#4D8EF6'} : {backgroundColor:'#68BA3D'}">
            <span>{{data.required == 1 ? '必修' : '選修'}}</span>
        </div>
        <p class="title omit" :title="data.name">{{data.name}}</p>
        <div class="time">
            <div class="time-box">
                <img class="icon" src="../../assets/images/icon/meditor-time.png" alt="">
                <span style="margin-left:5px">學習時間</span>
            </div>
            <span class="time-top">{{`${getTime(data.study_begin_date)}至${getTime(data.study_of_date)}`}}</span>
        </div>
    </el-card>
</template>
<script>
import { formatDateTime } from '@/utils';

export default {
    props:{
        data: {
            type: Object,
        }
    },
    methods:{
        getTime(v){
            return formatDateTime(v,'yyyy-MM-dd HH:mm')
        }
    }
}
</script>
<style lang="less" scoped>
.el-card, .el-message{
    border-radius: 8px;
}
.lesson {
    width: 230px;
    height: 200px;
    margin-right: 8px;
    margin-bottom: 24px;
    .required{
        width: 220px;
        height: 40px;
        text-align: center;
        color: #fff;
        font-weight:600;
        font-size: 17px;
        line-height: 40px;
        border-radius: 6px 6px 0 0;
    }
    .title{
        margin-top: 13px;
        height: 22px;
        font-size: 16px;
        line-height: 22px;
        color: #404040;
    }
    .time{
        margin-top: 7px;
        height: 13px;
        text-align:justify;
        white-space:nowrap;
        font-size: 12px;
        line-height: 13px;
        color: rgba(51,51,51);
        .time-top{
            color:rgba(51,51,51,0.80);
            margin-top:10px;
            display: inline-block;
        }
        .time-box{
            margin-top: 14px;
        }
    }
}
</style>